export const innerWidth = globalThis.innerWidth !== undefined ? window.innerWidth : 1200;

export const innerHeight = globalThis.innerWidth !== undefined ? window.innerWidth : 960;

export const isBrowser = typeof window !== 'undefined';
